export const LIST_CLIENT_REQUEST = 'LIST_CLIENT_REQUEST'
export const LIST_CLIENT_SUCCESS = 'LIST_CLIENT_SUCCESS'
export const LIST_CLIENT_FAIL = 'LIST_CLIENT_FAIL'

export const LIST_CLIENT_SUMMARY_REQUEST = 'LIST_CLIENT_SUMMARY_REQUEST'
export const LIST_CLIENT_SUMMARY_SUCCESS = 'LIST_CLIENT_SUMMARY_SUCCESS'
export const LIST_CLIENT_SUMMARY_FAIL = 'LIST_CLIENT_SUMMARY_FAIL'

export const LIST_CLIENT_PROJECT_SUMMARY_REQUEST =
  'LIST_CLIENT_PROJECT_SUMMARY_REQUEST'
export const LIST_CLIENT_PROJECT_SUMMARY_SUCCESS =
  'LIST_CLIENT_PROJECT_SUMMARY_SUCCESS'
export const LIST_CLIENT_PROJECT_SUMMARY_FAIL =
  'LIST_CLIENT_PROJECT_SUMMARY_FAIL'

export const CREATE_CLIENT_REQUEST = 'CREATE_CLIENT_REQUEST'
export const CREATE_CLIENT_SUCCESS = 'CREATE_CLIENT_SUCCESS'
export const CREATE_CLIENT_FAIL = 'CREATE_CLIENT_FAIL'

export const DETAIL_CLIENT_REQUEST = 'DETAIL_CLIENT_REQUEST'
export const DETAIL_CLIENT_SUCCESS = 'DETAIL_CLIENT_SUCCESS'
export const DETAIL_CLIENT_FAIL = 'DETAIL_CLIENT_FAIL'

export const UPDATE_CLIENT_REQUEST = 'UPDATE_CLIENT_REQUEST'
export const UPDATE_CLIENT_SUCCESS = 'UPDATE_CLIENT_SUCCESS'
export const UPDATE_CLIENT_FAIL = 'UPDATE_CLIENT_FAIL'

export const DELETE_CLIENT_REQUEST = 'DELETE_CLIENT_REQUEST'
export const DELETE_CLIENT_SUCCESS = 'DELETE_CLIENT_SUCCESS'
export const DELETE_CLIENT_FAIL = 'DELETE_CLIENT_FAIL'

export const LIST_INVOICE_ADDRESS_REQUEST = 'LIST_INVOICE_ADDRESS_REQUEST'
export const LIST_INVOICE_ADDRESS_SUCCESS = 'LIST_INVOICE_ADDRESS_SUCCESS'
export const LIST_INVOICE_ADDRESS_FAIL = 'LIST_INVOICE_ADDRESS_FAIL'

export const CREATE_INVOICE_ADDRESS_REQUEST = 'CREATE_INVOICE_ADDRESS_REQUEST'
export const CREATE_INVOICE_ADDRESS_SUCCESS = 'CREATE_INVOICE_ADDRESS_SUCCESS'
export const CREATE_INVOICE_ADDRESS_FAIL = 'CREATE_INVOICE_ADDRESS_FAIL'

export const DETAIL_INVOICE_ADDRESS_REQUEST = 'DETAIL_INVOICE_ADDRESS_REQUEST'
export const DETAIL_INVOICE_ADDRESS_SUCCESS = 'DETAIL_INVOICE_ADDRESS_SUCCESS'
export const DETAIL_INVOICE_ADDRESS_FAIL = 'DETAIL_INVOICE_ADDRESS_FAIL'

export const UPDATE_INVOICE_ADDRESS_REQUEST = 'UPDATE_INVOICE_ADDRESS_REQUEST'
export const UPDATE_INVOICE_ADDRESS_SUCCESS = 'UPDATE_INVOICE_ADDRESS_SUCCESS'
export const UPDATE_INVOICE_ADDRESS_FAIL = 'UPDATE_INVOICE_ADDRESS_FAIL'

export const DELETE_INVOICE_ADDRESS_REQUEST = 'DELETE_INVOICE_ADDRESS_REQUEST'
export const DELETE_INVOICE_ADDRESS_SUCCESS = 'DELETE_INVOICE_ADDRESS_SUCCESS'
export const DELETE_INVOICE_ADDRESS_FAIL = 'DELETE_INVOICE_ADDRESS_FAIL'

export const RESET_DETAIL_INVOICE_ADDRESS = 'RESET_DETAIL_INVOICE_ADDRESS'

export const LIST_CLIENT_DOCUMENT_REQUEST = 'LIST_CLIENT_DOCUMENT_REQUEST'
export const LIST_CLIENT_DOCUMENT_SUCCESS = 'LIST_CLIENT_DOCUMENT_SUCCESS'
export const LIST_CLIENT_DOCUMENT_FAIL = 'LIST_CLIENT_DOCUMENT_FAIL'

export const CREATE_CLIENT_DOCUMENT_REQUEST = 'CREATE_CLIENT_DOCUMENT_REQUEST'
export const CREATE_CLIENT_DOCUMENT_SUCCESS = 'CREATE_CLIENT_DOCUMENT_SUCCESS'
export const CREATE_CLIENT_DOCUMENT_FAIL = 'CREATE_CLIENT_DOCUMENT_FAIL'

export const UPDATE_CLIENT_DOCUMENT_REQUEST = 'UPDATE_CLIENT_DOCUMENT_REQUEST'
export const UPDATE_CLIENT_DOCUMENT_SUCCESS = 'UPDATE_CLIENT_DOCUMENT_SUCCESS'
export const UPDATE_CLIENT_DOCUMENT_FAIL = 'UPDATE_CLIENT_DOCUMENT_FAIL'

export const DELETE_CLIENT_DOCUMENT_REQUEST = 'DELETE_CLIENT_DOCUMENT_REQUEST'
export const DELETE_CLIENT_DOCUMENT_SUCCESS = 'DELETE_CLIENT_DOCUMENT_SUCCESS'
export const DELETE_CLIENT_DOCUMENT_FAIL = 'DELETE_CLIENT_DOCUMENT_FAIL'

export const DOWNLOAD_CLIENT_DOCUMENT_REQUEST = 'DOWNLOAD_CLIENT_DOCUMENT_REQUEST'
export const DOWNLOAD_CLIENT_DOCUMENT_SUCCESS = 'DOWNLOAD_CLIENT_DOCUMENT_SUCCESS'
export const DOWNLOAD_CLIENT_DOCUMENT_FAIL = 'DOWNLOAD_CLIENT_DOCUMENT_FAIL'

export const LIST_CLIENT_DOCUMENT_CLASSIFICATION_REQUEST =
  'LIST_CLIENT_DOCUMENT_CLASSIFICATION_REQUEST'
export const LIST_CLIENT_DOCUMENT_CLASSIFICATION_SUCCESS =
  'LIST_CLIENT_DOCUMENT_CLASSIFICATION_SUCCESS'
export const LIST_CLIENT_DOCUMENT_CLASSIFICATION_FAIL =
  'LIST_CLIENT_DOCUMENT_CLASSIFICATION_FAIL'
